import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import GrainOverlay from "@/components/GrainOverlay";
import Cursor from "@/components/Cursor";
import Site from "@/pages/Site";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <GrainOverlay />
      <Cursor />
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0B0B0C",
            border: "1px solid #252527",
            color: "#F4F3EF",
            borderRadius: 0,
            fontFamily: "Inter, sans-serif",
            fontSize: "13px",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Site />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
